import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import CustomDatasetActionImage from './CustomDatasetActionImage';

const CustomDatasetActionDropdownItem = ({
  label,
  url,
  description,
  target,
  disabled,
}) => (
  <Dropdown.Item
    as="a"
    title={description}
    selected={false}
    href={disabled ? null : url}
    target={target}
    disabled={disabled}
    className="aridhia-custom-dataset-dropdown-item flex flex-row"
    rel="noopener noreferrer"
  >
    <CustomDatasetActionImage description={description} label={label} />
    <div>{label}</div>
  </Dropdown.Item>
);

export default CustomDatasetActionDropdownItem;
